(window as any).$ = (window as any).jQuery = require('jquery');
